import PropTypes from "prop-types";
import { SecondaryPrice } from "../priceComponents";
import styles from "./TitleThenPrice.scss";

export default function TitleThenPrice({
  priceData,
  title,
  showAdvertElements,
}) {
  const titleWithABActive = showAdvertElements
    ? styles.titleWithABActive
    : styles.title;

  return (
    <>
      <span
        className={titleWithABActive}
        title={title}
        data-testid="product-title"
      >
        {title}
      </span>
      <SecondaryPrice priceData={priceData} />
    </>
  );
}

TitleThenPrice.propTypes = {
  priceData: PropTypes.shape({
    current: PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    }).isRequired,
    previous: PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    }),
    rrp: PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    }),
    isMarkedDown: PropTypes.bool,
    isOutletPrice: PropTypes.bool,
  }).isRequired,
  title: PropTypes.string.isRequired,
  showAdvertElements: PropTypes.bool,
};
